import { Pipe, PipeTransform } from '@angular/core';
import { UpdateAppointmentHistoryJob } from 'projects/Administration/src/app/business-entities/appointmentDetail-model';

@Pipe({
    name: 'StringToTablePipe'
})
export class StringToTablePipe implements PipeTransform {

    constructor(
    ) { 
      // This is intentional
    }

    transform(deatils: any,isAdditional: boolean): any {
        const arra =[]
        deatils.forEach(element => {
          if(element?.toString().includes(",")){
          let obj:UpdateAppointmentHistoryJob={
            description:"",
            jobId:0,
            salesPrice:0,
            totalTime:0,
            isAdminApproved:0,
            isCDSSApproved:0,
            isCustomerApporved:0,
            canBeDoneNow:0,
            isMechanicApproved:0,
            packageNo:""
          }
          let arr = element.split(",");
          if(arr && arr.length >0 && !isAdditional){
            obj.description = arr[1];
            obj.jobId = +arr[0];
            obj.salesPrice = arr[2];
            obj.totalTime = arr[3];
            obj.packageNo = arr[4];
          }
          if(arr && arr.length >0 && isAdditional){
            obj.description = arr[1];
            obj.jobId = +arr[0];
            obj.salesPrice = arr[2];
            obj.totalTime = arr[3];
            obj.isAdminApproved = arr[4];
            obj.isCDSSApproved = arr[5];
            obj.isCustomerApporved = arr[6];
            obj.isMechanicApproved = arr[7];
            obj.canBeDoneNow = arr[8].toString().trim();
          }
          arra.push(obj);
        }
           
        })
        return arra;
        
    }
}


